import { Backdrop, CircularProgress } from '@mui/material'
import React from 'react'

const Loader = () => {
    return (
        <Backdrop
            sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.modal + 1 }}
            open={true} // Show loader when data is loading
        >
            <CircularProgress color="inherit" />
        </Backdrop>)
}

export default Loader